module.exports = __webpack_public_path__ + "img/clemson.7b8cf692.svg";